export default __webpack_public_path__ + "static/img_desktop_7-566f9139dc4811b92adc022508189d57.jpg";